import { SCAN_SERVICE_TYPE } from '@witmetrics/utils/constants';
import OrthoIcon from '@/icons/cases/OrthoIcon';
import NightguardIcon from '@/icons/cases/NightguardIcon';
import OtherCaseIcon from '@/icons/cases/OtherCaseIcon';
import RetainersIcon from '@/icons/cases/RetainersIcon';

const {
  MODEL_BUILDER_V1,
  RETAINER_DIRECT_PRINTED_V1,
  BLEACHING_TRAY_MODELS_V1,
  MICHIGAN_SPLINT_V1,
  NIGHTGUARD_V1,
} = SCAN_SERVICE_TYPE;

export const ICONS = {
  [BLEACHING_TRAY_MODELS_V1]: RetainersIcon,
  [MICHIGAN_SPLINT_V1]: NightguardIcon,
  [NIGHTGUARD_V1]: NightguardIcon,
  [RETAINER_DIRECT_PRINTED_V1]: RetainersIcon,
  [MODEL_BUILDER_V1]: OrthoIcon, // TODO: Replace with Model Builder Icon when available
  DEFAULT: OtherCaseIcon,
} as const;
